
































import { Component, Mixins } from 'vue-property-decorator'
import { __ } from 'bits/intl'
import BaseIcon from 'vuecomponents/base_icon.vue'
import DropdownMobile from 'library/v4/components/dropdown-mobile.vue'

@Component({
  components: {
    BaseIcon,
    DropdownMobile,
  },
})
export default class MembershipFooter extends Mixins() {
  moreServices = [
    {
      title: __('Sign up'),
      link: '/auth/signup',
    },
    {
      title: __('About'),
      link: '/about/us',
    },
    {
      title: __('Jobs'),
      link: 'https://padlet.jobs',
    },
    {
      title: __('Support'),
      link: 'https://padlet.help',
    },
    {
      title: __('Accessibility statement'),
      link: '/about/accessibility',
    },
    {
      title: __('Privacy policy'),
      link: '/about/privacy',
    },
    {
      title: __('Terms of service'),
      link: '/about/terms',
    },
    {
      title: __('Content policy'),
      link: '/about/content',
    },
  ]

  mounted() {
    if (window.location.href.endsWith('/memberships') || window.location.href.includes('/membership')) {
      document.getElementById('membership')?.classList.add('active')
    } else if (window.location.href.includes('/features')) {
      document.getElementById('product')?.classList.add('active')
    } else {
      document.getElementById('home')?.classList.add('active')
    }
  }
}
